function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-cuve-exterieure");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-cuve-exterieure",
  fill: "#D93252"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24,24 L23,24 L22,21 L8,21 L7,24 L6,24 L6,21 L3,21 C2,18.8333333 1.5,16.6666667 1.5,14.5 C1.5,12.3333333 2,10.1666667 3,8 L27,8 C28,10.1666667 28.5,12.3333333 28.5,14.5 C28.5,16.6666667 28,18.8333333 27,21 L24,21 L24,24 Z",
  id: "Combined-Shape"
})));

const SvgIco30CuveExterieure = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30CuveExterieure, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-cuve-exterieure.aebb57c0.svg";
export { ForwardRef as ReactComponent };